// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"RO","productsContainer":"SO","searchVerticalReco":"TO","heading":"UO"};